// Generated by ReScript, PLEASE EDIT WITH CARE

import * as AssetStore$PorterinFeature from "../../../../ui/assets/AssetStore.mjs";

var commonAssetPath = "/assets/icons/common/booking-flow/";

var input_from_icon = {
  src: AssetStore$PorterinFeature.fromInput,
  width: 16.0,
  height: 16.0,
  alt: "From Address Icon"
};

var input_from_icon_v2 = {
  path: AssetStore$PorterinFeature.fromInput,
  alt_text: "From Address Icon"
};

var input_to_icon = {
  src: AssetStore$PorterinFeature.dropPin,
  width: 16.0,
  height: 16.0,
  alt: "To Address Icon"
};

var input_to_icon_v2 = {
  path: AssetStore$PorterinFeature.dropPin,
  alt_text: "To Address Icon"
};

var input_mobile_icon_src = commonAssetPath + "mobile-input.svg";

var input_mobile_icon = {
  src: input_mobile_icon_src,
  width: 18.0,
  height: 18.0,
  alt: "Mobile Icon"
};

var input_mobile_icon_v2_path = commonAssetPath + "mobile-input.svg";

var input_mobile_icon_v2 = {
  path: input_mobile_icon_v2_path,
  alt_text: "Mobile Icon"
};

var input_name_icon = {
  src: AssetStore$PorterinFeature.nameInput,
  width: 18.0,
  height: 18.0,
  alt: "Name Icon"
};

var drop_arrow_field_src = commonAssetPath + "drop-arrow-filled.svg";

var drop_arrow_field = {
  src: drop_arrow_field_src,
  width: 20.0,
  height: 20.0,
  alt: "Drop Arrow Icon"
};

export {
  commonAssetPath ,
  input_from_icon ,
  input_from_icon_v2 ,
  input_to_icon ,
  input_to_icon_v2 ,
  input_mobile_icon ,
  input_mobile_icon_v2 ,
  input_name_icon ,
  drop_arrow_field ,
}
/* No side effect */
